(function (angular, schoolwork12) {
    
    'use strict';
    angular.module(schoolwork12.app.student.name)

    .factory(schoolwork12.app.student.services.studentAttendanceAdjustmentSvc, 
        ['$filter', '$http', '$q',  function( $filter, $http, $q) {

  		var getAttendanceAdjustmentTypes = function (keycode) {
            console.info('In getAttendanceAdjustmentTypes service');
            console.info('Making a call to service');
            var subjects = null;
            var deferred = $q.defer();
            var request = $http({
                cache:true,
                method: 'GET',
                url: schoolwork12.app.student.endpoints.attendanceAdjType,
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                }
            });
            request.then(function (response) {
                subjects = response.data;
                deferred.resolve(subjects);
                console.info('Got the attendance adjustment types');
            }, function (error) {  
                deferred.reject(error);
            });
            return deferred.promise;
        };

        var getAttendanceAdjustmentReasons = function (keycode) {
            console.info('In getAttendanceAdjustmentReasons service');
            console.info('Making a call to service');
            var subjects = null;
            var deferred = $q.defer();
            var request = $http({
                cache:true,
                method: 'GET',
                url: schoolwork12.app.student.endpoints.attendanceAdjReason,
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                }
            });
            request.then(function (response) {
                subjects = response.data;
                deferred.resolve(subjects);
                console.info('Got the attendance adjustment reasons');
            }, function (error) {  
                deferred.reject(error);
            });
            return deferred.promise;
        };

        function isFloat(n){
            return Number(n) === n && n % 1 !== 0;
        }

        function isValid($scope, index, item, school){
            var errors = [];
            var startDate, endDate, schoolStartDate, schoolEndDate;
            var _schoolStartDate = school.startDate.split('/');
            var _schoolEndDate = school.endDate.split('/');

            schoolStartDate = new Date(_schoolStartDate[2], _schoolStartDate[0]-1, _schoolStartDate[1]);
            schoolEndDate = new Date(_schoolEndDate[2], _schoolEndDate[0]-1, _schoolEndDate[1]);
            
            $scope.forms.attdjForms['attdjForm_' +index]["attdjStartDate_"+index].$setValidity('startDateWrongFormat', true);
            $scope.forms.attdjForms['attdjForm_' +index]["attdjStartDate_"+index].$setValidity('startDateRequired', true);
            $scope.forms.attdjForms['attdjForm_' +index]["attdjStartDate_"+index].$setValidity('startDateValid', true);
            
            var startDateVal = $scope.forms.attdjForms['attdjForm_' +index]["attdjStartDate_"+index].$viewValue;
			var sd = new Date(startDateVal);
			if((startDateVal != null && startDateVal != "") && sd == 'Invalid Date'){
				errors.push("Invalid Start Date. Enter in MM/DD/YYYY format.");
				$scope.forms.attdjForms['attdjForm_' +index]["attdjStartDate_"+index].$setValidity('startDateWrongFormat', false);
			}else{
				if (!item.startDate) {
	                $scope.forms.attdjForms['attdjForm_' +index]["attdjStartDate_"+index].$setValidity('startDateRequired', false);
					errors.push("Start Date is required");
				} else {
	                startDate = item.startDate;
					if (startDate < schoolStartDate) {
						errors.push("Start Date must be on or after the current school year start date");
	                    $scope.forms.attdjForms['attdjForm_' +index]["attdjStartDate_"+index].$setValidity('startDateValid', false);
					}
				}
			}
            
			if (!item.type) {
                $scope.forms.attdjForms['attdjForm_' +index]["attdjType_"+index].$setValidity('typeRequired', false);
				errors.push("Type is required");
			}else{
                $scope.forms.attdjForms['attdjForm_' +index]["attdjType_"+index].$setValidity('typeRequired', true);
            }

			if (!item.reason) {
                $scope.forms.attdjForms['attdjForm_' +index]["attdjReason_"+index].$setValidity('reasonRequired', false);
				errors.push("Reason is required");
			}else{
                $scope.forms.attdjForms['attdjForm_' +index]["attdjReason_"+index].$setValidity('reasonRequired', true);
            }
			$scope.forms.attdjForms['attdjForm_' +index]["attdjEndDate_"+index].$setValidity('endDateRequiredForTypeSMDP', true);
            $scope.forms.attdjForms['attdjForm_' +index]["attdjEndDate_"+index].$setValidity('endDateRequiredForTypeEA', true);
            $scope.forms.attdjForms['attdjForm_' +index]["attdjEndDate_"+index].$setValidity('endDateWrongFormat', true);
            $scope.forms.attdjForms['attdjForm_' +index]["attdjEndDate_"+index].$setValidity('endDateValidSSD', true);
            $scope.forms.attdjForms['attdjForm_' +index]["attdjEndDate_"+index].$setValidity('endDateValidSD', true);
            
            var endDateVal = $scope.forms.attdjForms['attdjForm_' +index]["attdjEndDate_"+index].$viewValue;
			var ed = new Date(endDateVal);
			if((endDateVal != null && endDateVal != "") && ed == 'Invalid Date'){
				errors.push("Invalid End Date. Enter in MM/DD/YYYY format.");
				$scope.forms.attdjForms['attdjForm_' +index]["attdjEndDate_"+index].$setValidity('endDateWrongFormat', false);
			}else{
				if (!item.endDate) {
					if (item.type == "School marked day(s) present") {
						errors.push("End Date is required for School marked day(s) present");
	                    $scope.forms.attdjForms['attdjForm_' +index]["attdjEndDate_"+index].$setValidity('endDateRequiredForTypeSMDP', false);
					} else if (item.type == "Excused absence") {
	                    $scope.forms.attdjForms['attdjForm_' +index]["attdjEndDate_"+index].$setValidity('endDateRequiredForTypeEA', false);
						errors.push("End Date is required for an Excused absence");
					}
				} else {
					endDate = item.endDate;

					if (endDate > schoolEndDate) {
						errors.push("End Date must be on or before the current school year end date");
	                    $scope.forms.attdjForms['attdjForm_' +index]["attdjEndDate_"+index].$setValidity('endDateValidSSD', false);
					}else{
						if (startDate != null && endDate != null && endDate < startDate) {
							errors.push("End Date must be greater than or equal to the Start Date");
		                    $scope.forms.attdjForms['attdjForm_' +index]["attdjEndDate_"+index].$setValidity('endDateValidSD', false);
						}
	                }
				}
			}
            
			
			if (item.percent == null) {
				errors.push("Percent Absent is required");
                $scope.forms.attdjForms['attdjForm_' +index]["attdjPercent_"+index].$setValidity('percentValid', false);
			}else if(isFloat(item.percent)){
                errors.push("Percent Absent is required");
                $scope.forms.attdjForms['attdjForm_' +index]["attdjPercent_"+index].$setValidity('percentValid', false);
            }else if(item.percent<0 || item.percent>100){
                errors.push("Percent Absent is required");
                $scope.forms.attdjForms['attdjForm_' +index]["attdjPercent_"+index].$setValidity('percentValid', false);
            }else{
                $scope.forms.attdjForms['attdjForm_' +index]["attdjPercent_"+index].$setValidity('percentValid', true);
            }
            return errors.length === 0;
        }

        var updateAttendaceAdjustment = function($scope, dataAttdj, keycode, schools) {
            $scope.isSaveBusy = false;
            var data = {
                "studentStatus": $scope.student.status,
                "items": []
            };
            var school, hasErrors = false;
            angular.forEach(schools, function(item){
                if(item.schoolId == $scope.editStudent.schoolId){
                    school = item;
                }
            });
            
            angular.forEach(dataAttdj, function (row, index) {
                if (row.isEdited) {
                    var typeId, reasonId;

                    angular.forEach($scope.attendanceAdjustmentReasons, function (item) {
                        if(item.name==row.reason){
                            reasonId = item.id;
                        }
                    });
                    angular.forEach($scope.attendanceAdjustmentTypes, function (item) {
                        if(item.name==row.type){
                            typeId = item.id;
                        }
                    });
                    if(isValid($scope, index, row, school)){
                        data["items"].push({
                            "id": row.id,
                            "startDate": $filter('date')(row.startDate, 'MM/dd/yyyy'),
                            "endDate": $filter('date')(row.endDate, 'MM/dd/yyyy'),
                            "percent": row.percent,
                            "excuser": row.excuser,
                            "typeId": typeId,
                            "type": row.type,
                            "reasonId": reasonId,
                            "reason": row.reason,
                            "comments": row.comments
                        });
                    }else{
                        hasErrors=true;
                        return;
                    }
                }
            });
            if(!hasErrors && data["items"].length){
                $scope.isSaveBusy = true;

                $http({
                    url: schoolwork12.app.student.endpoints.studentAdjustAttendance + $scope.studentRow.entity.studentId,
                    method: "PUT",
                    data: data,
                    params: {
                        schoolAbbr: $scope.studentRow.entity.schoolAbbr
                    },
                    headers: {
                        'X-API-TOKEN': keycode,
                    }
                }).then(function(response) {
                    $scope.resetForms();
                    $scope.isSaveBusy = false;
                    $scope.currentAttAdjInfo = angular.copy($scope.gridAttendanceData);
                    $scope.showSavedStudentMsg = true;
                    $scope.savedStudent = true;
                    $scope.isAttendanceAdjustmentSave = false;
                    $scope.getAttAdjTotals();
                    angular.forEach(dataAttdj, function (row) {
                        row.isEdited = false;
                    });

                    console.info("View saved student attendance adjustment info", response);
                }, function(error) {
                    console.info('Error in saving student details....'.concat(angular.toJson(error)));
                    $scope.editErrorOccurred = true;
                    $scope.showSavedStudentMsg = false;
                    $scope.isSaveBusy = false;

                    $scope.savedStudent = false;
                    $scope.editErrorMesg = "";

                    if (error.status == 400) {
                        for (var j = 0; j < error.data._errors.length; j++) {
                            $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                        }
                    } else if (error.status == 401 || error.status == 403) {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                    } else {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                    }
                });
            }
        };
        
        var removeAttendaceAdjustment = function($scope, dataAttdj, keycode) {
            $scope.isSaveBusy = false;
            var data = {
                "studentStatus": $scope.student.status,
                "items": []
            };
            angular.forEach(dataAttdj, function (row, index) {
            	data["items"].push({
                    "id": row.id
                });
            });
            if(data["items"].length > 0){
                $scope.isSaveBusy = true;

                $http({
                    url: schoolwork12.app.student.endpoints.studentAdjustAttendance + $scope.studentRow.entity.studentId,
                    method: "PATCH",
                    params: {
                                schoolAbbr: $scope.studentRow.entity.schoolAbbr
                            },
                    data: data,
                    headers: {
                        'X-API-TOKEN': keycode,
                    }
                }).then(function(response) {
                    $scope.resetForms();
                    $scope.isSaveBusy = false;
                    $scope.attAdjToRemove = [];
                    $scope.showSavedStudentMsg = true;
                    $scope.savedStudent = true;
                    $scope.isAttendanceAdjustmentSave = false;
                    $scope.currentAttAdjInfo = angular.copy($scope.gridAttendanceData);
                    $scope.getAttAdjTotals();
                    console.info(response);
                }, function(error) {
                    console.info('Error removing student attendance adjustment....'.concat(angular.toJson(error)));
                    $scope.editErrorOccurred = true;
                    $scope.showSavedStudentMsg = false;
                    $scope.isSaveBusy = false;

                    $scope.savedStudent = false;
                    $scope.editErrorMesg = "";

                    if (error.status == 400) {
                        for (var j = 0; j < error.data._errors.length; j++) {
                            $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                        }
                    } else if (error.status == 401 || error.status == 403) {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                    } else {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                    }
                });
            }
        };

    return {
        updateAttendaceAdjustment: updateAttendaceAdjustment,
    	getAttendanceAdjustmentTypes: getAttendanceAdjustmentTypes,
        getAttendanceAdjustmentReasons: getAttendanceAdjustmentReasons,
        removeAttendaceAdjustment: removeAttendaceAdjustment
    };

}]);
    
}(angular, schoolwork12));